// Miky Motorsport - rivaluv ghost (J): synteticka trajektorie po ose trate cilovym tempem.
// Vrati frames kompatibilni s GhostPlayer ([{x,y,z,qx,qy,qz,qw}]), takze rivala honis
// jako vizualni ghost auto. Cista logika (bez DOM/THREE) - testovatelne v Node.
//
// Rival jede konstantni rychlosti po centerline (osa trate). To neni dokonala zavodni
// stopa, ale je to spravne tempo a spravny smer - jako "duch" rivala k dohoneni.

// Yaw kvaternion (otoceni kolem Y). Shoduje se s vehicleMath.yawQuat - auto ma forward +Z,
// heading = atan2(tangent.x, tangent.z), takze ghost auto miri po trati.
function yawQuat(rad) {
  const h = rad * 0.5;
  return { y: Math.sin(h), w: Math.cos(h) };
}

// centerline = [{x,z}, ...] (uzavreny okruh, vzorky osy). lapMs = cas na 1 kolo,
// laps = pocet kol, dtMs = vzorkovani. opts.groundY(x,z) -> vyska terenu, opts.yOffset
// = vyska tela auta nad osou (default 0.55 m).
export function buildRivalGhostFrames(centerline, lapMs, laps, dtMs = 1000 / 30, opts = {}) {
  const N = centerline ? centerline.length : 0;
  if (N < 2 || !(lapMs > 0) || !(laps > 0) || !(dtMs > 0)) return [];
  const groundY = typeof opts.groundY === 'function' ? opts.groundY : null;
  const yOffset = opts.yOffset != null ? opts.yOffset : 0.55;

  // kumulativni delka oblouku (uzavreny okruh: posledni segment N-1 -> 0)
  const cum = new Array(N + 1);
  cum[0] = 0;
  for (let i = 0; i < N; i++) {
    const a = centerline[i];
    const b = centerline[(i + 1) % N];
    cum[i + 1] = cum[i] + Math.hypot(b.x - a.x, b.z - a.z);
  }
  const lapLen = cum[N];
  if (!(lapLen > 0)) return [];

  // bod + tangenta na pozici arc-length s (0..lapLen). seg = hint pro rychlejsi scan.
  let seg = 0;
  const sample = (s) => {
    s = ((s % lapLen) + lapLen) % lapLen;
    if (s < cum[seg]) seg = 0; // wrap (novy okruh) -> scan od zacatku
    while (seg < N && cum[seg + 1] <= s) seg++;
    if (seg >= N) seg = N - 1;
    const a = centerline[seg];
    const b = centerline[(seg + 1) % N];
    const segLen = cum[seg + 1] - cum[seg] || 1e-6;
    const f = (s - cum[seg]) / segLen;
    const x = a.x + (b.x - a.x) * f;
    const z = a.z + (b.z - a.z) * f;
    // tangenta = smer segmentu; heading = atan2(tx, tz) (forward +Z, jako auto)
    const tx = b.x - a.x, tz = b.z - a.z;
    const heading = Math.atan2(tx, tz);
    return { x, z, heading };
  };

  const totalMs = lapMs * laps;
  // ceil (ne floor): prehravani ghostu trva (frames.length-1)*dtMs, takze ceil zajisti,
  // ze doba prehravani POKRYJE cely cilovy cas totalMs (jinak by ghost dojel az o dtMs driv,
  // kdyz totalMs neni presny nasobek dtMs).
  const frameCount = Math.max(2, Math.ceil(totalMs / dtMs) + 1);
  const frames = new Array(frameCount);
  for (let k = 0; k < frameCount; k++) {
    const t = k * dtMs;
    const d = (t / lapMs) * lapLen; // ujeta vzdalenost
    const p = sample(d);
    const y = (groundY ? groundY(p.x, p.z) : 0) + yOffset;
    const q = yawQuat(p.heading);
    frames[k] = { x: p.x, y, z: p.z, qx: 0, qy: q.y, qz: 0, qw: q.w };
  }
  return frames;
}
